/**
 * Anchor Subnav
 *
 * @version 	2026.01.09
 * @name   		CSlice\JS\Anchor_Subnav
 */

document.addEventListener('DOMContentLoaded', () => {
	const subNav = document.querySelector('.Subnav.is-pattern');
	if (subNav != null) {
		const anchorNavContainer = subNav.querySelector('.Subnav-page');
		const anchorNavItems =
			anchorNavContainer != null ? [...anchorNavContainer.getElementsByTagName('p')] : [];

		// Set up anchor nav items
		if (anchorNavItems != null && anchorNavItems.length > 0) {
			let visibleSections = [];
			let hashIds = [];

			/**
			 * On load, make sure all nav items have existing targets
			 * And set up hashIds
			 */
			const setupAnchorNavItems = () => {
				const anchorNavLinks = [...anchorNavContainer.querySelectorAll('a')];
				if (anchorNavLinks.length > 0) {
					hashIds = [];
					anchorNavLinks.forEach((link) => {
						const targetId = link.hash.replace('#', '');
						// Update hashIds array
						hashIds.push(targetId);
						// Hide if no target exists on the page
						const target = document.getElementById(targetId);
						if (target == null) {
							link.parentElement.classList.add('isHidden');
						}
					});
				}
			};

			/**
			 * Add scroll listener
			 */
			const setupIntersectionObservers = () => {
				// empty visible sections array
				visibleSections = [];

				// Create intersection observer for nav controls
				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							// Reset nav items
							anchorNavItems.forEach((item) => {
								item.classList.remove('isSelected');
							});
							// Build list of currently visible sections
							if (entry.isIntersecting) {
								// Add ID to array when element becomes visible
								visibleSections.push(entry.target.id);
							} else {
								// Remove ID from array when element is no longer visible
								const index = visibleSections.indexOf(entry.target.id);
								if (index > -1) {
									visibleSections.splice(index, 1);
								}
							}

							// Force visible sections to match the order in nav list, so when scrolling up page, they are in an expected order
							visibleSections = visibleSections.sort((a, b) => {
								return hashIds.indexOf(a) - hashIds.indexOf(b);
							});

							// find the first hash id that is in the visibleSections array
							const firstVisibleSectionId = visibleSections.find((section) => {
								return hashIds.includes(section);
							});
							const firstVisibleLink = anchorNavContainer.querySelector(
								`a[href="#${firstVisibleSectionId}"]`
							);
							if (firstVisibleLink) {
								firstVisibleLink.parentElement.classList.add('isSelected');
								firstVisibleLink.parentElement.scrollIntoView({
									behavior: 'smooth',
									block: 'nearest',
									inline: 'center',
								});
							}
						});
					},
					{
						threshold: 0.1, // Element is considered visible when 10% is in view
						rootMargin: '-100px',
					}
				);

				// Add an observer to each element
				hashIds.forEach((hash) => {
					const element = document.getElementById(hash);
					if (element) {
						observer.observe(element);
					}
				});
			};

			setupAnchorNavItems();
			setupIntersectionObservers();
		}

		/**
		 * Update next/prev buttons
		 */
		const getCommunities = () => {
			// Get the communites list from local storage
			const communitiesStorage = JSON.parse(localStorage.getItem('tricon_communities'));
			let communities = null;
			if (
				communitiesStorage != null &&
				communitiesStorage.communities != null &&
				communitiesStorage.communities.length > 0
			) {
				communities = communitiesStorage.communities;

				// put communities in alphanumerical order
				communities.sort((a, b) => a.name.localeCompare(b.name));
			}
			return communities;
		};

		const getCurrentCommunity = (communities) => {
			// Get the slug from the url
			// Split by '/', filter empty values, and get the last segment
			const segments = window.location.pathname.split('/').filter(Boolean);
			const currentSlug = segments.at(-1) || '';
			const current = communities.find((community) => community.slug === currentSlug);
			return current;
		};

		const getLocalCommunities = (communities, current) => {
			// Get all communities in the same region
			const localCommunities = communities.filter(
				(community) => community.region_id === current.region_id
			);
			return localCommunities;
		};

		const setupNextPrev = () => {
			const nextButton = document.querySelector('.Subnav-next');
			const prevButton = document.querySelector('.Subnav-prev');
			if (nextButton != null && prevButton != null) {
				const communities = getCommunities();
				// Hide if we can't get communities list
				if (communities == null || communities.length < 1) {
					nextButton.classList.add('isHidden');
					prevButton.classList.add('isHidden');
				} else {
					const communityUrl = `${window.location.origin}/community/`;
					const currentCommunity = getCurrentCommunity(communities);
					// console.log('currentCommunity', currentCommunity);
					if (currentCommunity != null) {
						const localCommunities = getLocalCommunities(communities, currentCommunity);
						// console.log('localCommunities', localCommunities);

						if (localCommunities == null || localCommunities.length < 2) {
							nextButton.classList.add('isHidden');
							prevButton.classList.add('isHidden');
						} else {
							const currentIndex = localCommunities.findIndex(
								(community) => community.slug === currentCommunity.slug
							);
							// console.log('currentIndex', currentIndex);

							if (currentIndex == null) {
								nextButton.classList.add('isHidden');
								prevButton.classList.add('isHidden');
							} else {
								// Update prev button
								const prevCommunity =
									currentIndex === 0 ? null : localCommunities[currentIndex - 1];
								const prevButtonLink = prevButton.querySelector('a');
								if (prevCommunity != null && prevButtonLink != null) {
									// prevCommunity.path would work, but locks into the api urls vs local, etc
									prevButtonLink.href = `${communityUrl}${prevCommunity.slug}`;
								} else {
									prevButtonLink.classList.add('isDisabled');
								}
								// Update next button
								const nextCommunity =
									currentIndex === localCommunities.length - 1
										? null
										: localCommunities[currentIndex + 1];
								const nextButtonLink = nextButton.querySelector('a');
								if (nextCommunity != null && nextButtonLink != null) {
									// nextCommunity.path would work, but locks into the api urls vs local, etc
									nextButtonLink.href = `${communityUrl}${nextCommunity.slug}`;
								} else {
									nextButtonLink.classList.add('isDisabled');
								}
							}
						}
					}
				}
			}
		};

		setupNextPrev();
	}
});
